const { createAction } = require("../../helpers");
const {
  LIST_PROVIDERS,
  LIST_PROVIDERS_SUCCESS,
  LIST_PROVIDERS_RESET,
  LIST_PROVIDERS_ERROR,
} = require("./constants");

/**
 * @param {Array<string>} iatas
 * @return {Promise<*>}
 */

const listProviders = ({ id }) =>
  createAction(LIST_PROVIDERS,{id});

  
const listProvidersSuccess = (data) =>
  createAction(LIST_PROVIDERS_SUCCESS, { data });

const listProvidersError = (error) =>
  createAction(LIST_PROVIDERS_ERROR, { error });

const listProvidersReset = () => createAction(LIST_PROVIDERS_RESET);

module.exports = {
  listProviders,
  listProvidersSuccess,
  listProvidersError,
  listProvidersReset,
};
